/**
 * AI CONTEXT
 * Purpose: the student open in the Add/Edit student form. Watches the id
 * field so a student switch recomputes tabs instead of keeping the previous
 * student's pane.
 * Used by: StudentProfileTabs and its tab bodies.
 */
import { Form } from "antd"

import { type AddStudentFormValues } from "#customTypes/composedTypes/studentTypes"
import { type Uuid } from "#customTypes/globalTypes"
import { useGetOneStudent } from "#hooks/jotai/useGetStudents"

export const useStudentFromForm = () => {
  const form = Form.useFormInstance<AddStudentFormValues>()
  const studentId = Form.useWatch("id", form) as Uuid | undefined
  const student = useGetOneStudent(studentId)
  return { studentId, student }
}
